export default function CanAccessDashboard() {
  return true;
}